import { ModelTypes } from '@/typings/types/types';

export interface ClipboardState {
  elementInClipboard: ModelTypes | null;
  dataInClipboard: string | null;
}

export const state = (): ClipboardState => {
  return {
    elementInClipboard: null,
    dataInClipboard: null
  };
};
